module.exports = "pegasus/assets/themelp1/product/103.png";